import { ToggleSwitchProps } from './_models';
import IconSwitch from './components/Icon';
import LabelSwitch from './components/Label';

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  children,
  variant,
  label,
  checked,
  onChange,
  position,
}) => (
  <div className="d-flex align-items-center">
    {position === 'left' && children}
    {variant === 'label' && label ? (
      <LabelSwitch label={label} checked={checked} onChange={onChange} />
    ) : (
      <IconSwitch checked={checked} onChange={onChange} />
    )}
    {(position === 'right' || !position) && children}
  </div>
);

export default ToggleSwitch;
